import React from "react";
import { Grid, Typography } from "@mui/material";
import DateInput from "../../../components/DateInput";

/** 担当者在庫一覧　集計日付入力フォーム */
export default function StaffStockTotalDateForm({searchCondition, changeTotalDate}) {

  const totalDateValue = searchCondition.Value.totalDate;

  return (
    <Grid container alignItems="center" spacing={1} mb={1}>
      <Grid item xs textAlign="right">
        <Typography>対象日 : </Typography>
      </Grid>
      <Grid item xs='auto'>
        <DateInput
          value={totalDateValue}
          setValue={changeTotalDate}
        />
      </Grid>
    </Grid>
  )
  
}


